const STORAGE_KEY = "electionmap.selectionContext.v1";

function normalizeAreaId(areaId) {
  return String(areaId || "none");
}

function normalizeElectionId(value) {
  const id = String(value || "").trim();
  return id || "";
}

function normalizeChoice(value) {
  const choice = String(value || "").trim();
  return choice || "";
}

function readSelectionStore() {
  if (typeof window === "undefined" || !window.localStorage) return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (_) {
    return {};
  }
}

function writeSelectionStore(store) {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store && typeof store === "object" ? store : {}));
  } catch (_) {
    // Local storage is best-effort only.
  }
}

export function readElectionSelectionContext(areaId) {
  const store = readSelectionStore();
  const entry = store[normalizeAreaId(areaId)];
  return entry && typeof entry === "object" ? entry : {};
}

export function writeElectionSelectionContext(areaId, patch) {
  if (!patch || typeof patch !== "object") return;
  const store = readSelectionStore();
  const key = normalizeAreaId(areaId);
  store[key] = {
    ...(store[key] && typeof store[key] === "object" ? store[key] : {}),
    ...patch,
    updatedAt: Date.now(),
  };
  writeSelectionStore(store);
}

export function pickValidElectionId(elections, candidates, fallback = "") {
  const ids = new Set(
    (Array.isArray(elections) ? elections : [])
      .map((item) => normalizeElectionId(item && (item.id || item.election_id)))
      .filter(Boolean)
  );
  const choices = Array.isArray(candidates) ? candidates : [candidates];
  for (const choice of choices) {
    const id = normalizeElectionId(choice);
    if (id && ids.has(id)) return id;
  }
  const fallbackId = normalizeElectionId(fallback);
  if (fallbackId && ids.has(fallbackId)) return fallbackId;
  return "";
}

export function pickValidChoice(options, candidates, fallback = "") {
  const allowed = new Set((Array.isArray(options) ? options : []).map(normalizeChoice).filter(Boolean));
  const choices = Array.isArray(candidates) ? candidates : [candidates];
  for (const choice of choices) {
    const normalized = normalizeChoice(choice);
    if (normalized && allowed.has(normalized)) return normalized;
  }
  const fallbackChoice = normalizeChoice(fallback);
  if (fallbackChoice && allowed.has(fallbackChoice)) return fallbackChoice;
  return "";
}

export function getStoredChoiceForElection(selectionContext, mapKey, electionId) {
  const id = normalizeElectionId(electionId);
  const choicesByElection =
    selectionContext && selectionContext[mapKey] && typeof selectionContext[mapKey] === "object"
      ? selectionContext[mapKey]
      : {};
  return id ? normalizeChoice(choicesByElection[id]) : "";
}

export function setStoredChoiceForElection(selectionContext, mapKey, electionId, choice) {
  const id = normalizeElectionId(electionId);
  const normalizedChoice = normalizeChoice(choice);
  if (!id || !normalizedChoice) return selectionContext && selectionContext[mapKey] ? selectionContext[mapKey] : {};
  return {
    ...(selectionContext && selectionContext[mapKey] && typeof selectionContext[mapKey] === "object"
      ? selectionContext[mapKey]
      : {}),
    [id]: normalizedChoice,
  };
}
